import { render, staticRenderFns } from "./Devotional.vue?vue&type=template&id=0d23ab82&"
import script from "./Devotional.vue?vue&type=script&lang=js&"
export * from "./Devotional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports